import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FeedbackService } from '../manik-library/FeedbackService';
import { Title } from '@angular/platform-browser';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-happyornot',
  templateUrl: './happyornot.component.html',
  styleUrls: ['./happyornot.component.css'],
})
export class HappyornotComponent implements OnInit {
  rating: any = 0;
  Form1!: FormGroup;
  binding: any;

  checkboxList: any = [];
  staffList: any = [];
  companyData: any = {};
  headers: any;
  comments: any = '';
  files: any;
  filesStoredUrl: any = [];
  loginData: any;
  errorMessage = '';
  EmailID: any = '';
  MobileNumber: any = '';
  loginResponse: any = '';
  otpVerifyResponse: any = '';
  EnteredOTP: any = '';
  CitizenName: any = '';
  userData: any;
  data: any;
  header: any;
  CitizenHandle: any;
  isLoggedInVar = false;
  feedbackSubmit = false;
  SMSActivated: any;
  valid: boolean;
  otpSent: boolean = false;
  secondsToDelay: number = 0;
  sendingOtp: boolean = false;
  honoData: any;
  allowAnonymous: any;
  honoRating: any;
  currentSmileyPrompts: string[] = [];
  responseId: any;
  operationMode = 'A';
  submitted = false;
  loading: boolean = false;
  constructor(
    private _feedbackService: FeedbackService,
    public _routeParams: ActivatedRoute,
    private titleService: Title,
    private formBuilder: FormBuilder
  ) {
    this.titleService.setTitle('Happy or Not');
  }
  @ViewChild('otpModalButton') otpModalButton: any | undefined;
  @ViewChild('loginModalClose') loginModalClose: any | undefined;
  @ViewChild('nameModalClose') nameModalClose: any | undefined;
  @ViewChild('openloginname') openloginname: any | undefined;
  @ViewChild('otpModalClose') otpModalClose: any | undefined;
  @ViewChild('myloginModal') myloginModal: any;

  ngOnInit(): void {
    this.loading = true;
    this.Form1 = this.formBuilder.group({
      Email: [
        '',
        [Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')],
      ],
      Name: [''],
      Phone: [''],
      Comments: [''],
    });

    const headers = new HttpHeaders({
      TenantID: 'INSTA.WEB',
    });
    this._feedbackService.getToken(headers).subscribe((data) => {
      let Authorization = data['ManikJSon'][0]['JSon0'];
      sessionStorage.setItem('sToken', Authorization);
      this.getHonoData();
    });
  }

  getHappyForm(businessHandle: string) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
      Operation: 'FETCH.FEEDBACK.JSON',
      BusinessHandle: businessHandle,
      'Content-Type': 'application/json',
    });
    this._feedbackService.getFeebackFormData(headers).subscribe((data) => {
      this.companyData = data['ManikJSon'][0]['JSon0'][0];
      this.loginData = data['ManikJSon'][0]['JSon3'][0];

      if (this.honoData?.AllowSkipInfoWhenPrompted === 'N') {
        this.Form1.get('Name').setValidators([Validators.required]);
        this.Form1.get('Phone').setValidators([
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.minLength(this.loginData['MobileNumberLength']),
        ]);
      } else {
        this.Form1.get('Phone').setValidators([
          Validators.pattern('^[0-9]*$'),
          Validators.minLength(this.loginData['MobileNumberLength']),
        ]);
      }
      this.staffList = data['ManikJSon'][0]['JSon1'];
      this.loading = false;
    });
  }

  onClick() {
    if (this.honoData?.PromptUserInfo !== 'N') {
      if (this.honoData?.AllowSkipInfoWhenPrompted !== 'Y') {
        if (this.Form1.get('Name').invalid) {
          this.Form1.get('Name').markAsTouched();
          return;
        }
        if (this.Form1.get('Phone').invalid) {
          this.Form1.get('Phone').markAsTouched();
          return;
        }
        if (this.Form1.get('Email').invalid) {
          this.Form1.get('Email').markAsTouched();
          return;
        }
      } else {
        if (
          this.Form1.get('Phone').invalid &&
          !this.Form1.get('Phone').errors?.required
        ) {
          this.Form1.get('Phone').markAsTouched();
        }
        if (this.Form1.get('Email').invalid) {
          this.Form1.get('Email').markAsTouched();
          return;
        }
      }
      if (this.honoData?.VerifyCitizenship === 'N') {
        this.saveRatingAPI(this.rating, this.responseId);
      }
    }

    if (this.honoData?.VerifyCitizenship === 'Y') {
      if (this.isLoggedInVar) {
        let slug: string = this._routeParams.snapshot.params['businessslug'];
        let obj: any = {
          items: [
            {
              BusinessHandle: slug,
              ECommBranchID: '',
              CitizenHandle: this.CitizenHandle,
              Email: this.Form1.controls['Email'].value,
              Name: this.Form1.controls['Name'].value,
              Phone: this.Form1.controls['Phone'].value,
              Comments: this.Form1.controls['Comments'].value,
            },
          ],
        };

        let config = {
          headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
            'Content-Type': 'application/json',
            Context: 'SUBMIT.REVIEW',
            PortalDS: this.companyData['PortalDS'],
          },
        };
        this._feedbackService.addProfile(obj, config).then((res) => {
          try {
            if (this.filesStoredUrl.length) {
              let ReviewID = JSON.parse(res['data']['STATUS'])['ManikJSon'][0][
                'JSon0'
              ][0]['NewEntity'];
              let obj: any = {
                items: [],
              };
              this.filesStoredUrl.forEach((p) => {
                obj['items'].push({
                  ReviewID: ReviewID,
                  MediaType: 'I',
                  MediaURL: p,
                });
              });
              let config = {
                headers: {
                  Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
                  'Content-Type': 'application/json',
                  Context: 'SUBMIT.REVIEW.MEDIA',
                  PortalDS: this.companyData['PortalDS'],
                },
              };
              this._feedbackService.addProfile(obj, config).then((res) => {
                this.feedbackSubmit = true;
              });
            } else {
              this.feedbackSubmit = true;
            }
          } catch (e) {
            this.feedbackSubmit = true;
          }
        });
      } else {
        this.EmailID = this.Form1.value['Email'];
        this.MobileNumber = this.Form1.value['Phone'];

        if (this.EmailID || this.MobileNumber) {
          this.getOtpMobile(true);
        } else {
          this.myloginModal.nativeElement.click();
        }
      }
    } else if (
      this.honoData?.VerifyCitizenship === 'N' &&
      this.honoData?.PromptUserInfo === 'N'
    ) {
      this.reloadPageAfterNTime();
    }
  }

  getHonoData() {
    let slug: string = this._routeParams.snapshot.params['businessslug'];
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
      Operation: 'FETCH.HONO.DATA',
      HonoHandle: slug,
      'Content-Type': 'application/json',
    });
    this._feedbackService.getFeebackFormData(headers).subscribe((res) => {
      this.honoData = res['ManikJSon'][0]['JSon0'][0];
      this.currentSmileyPrompts = this.honoData?.SmileyPrompts.split(',');
      this.allowAnonymous = this.honoData?.AllowAnonymous;
      this.getHappyForm(this.honoData?.BusinessHandle);
    });
  }

  saveRatingAPI(numb, responseId?) {
    if (
      this.allowAnonymous === 'Y' &&
      this.honoData?.PromptUserInfo === 'A' &&
      responseId
    ) {
      this.reloadPageAfterNTime();
    } else if (
      this.allowAnonymous === 'Y' &&
      this.honoData?.PromptUserInfo === 'E' &&
      (responseId || numb > 2)
    ) {
      this.reloadPageAfterNTime();
    } else if (
      this.allowAnonymous === 'N' &&
      this.honoData?.VerifyCitizenship === 'N' &&
      responseId
    ) {
      this.reloadPageAfterNTime();
    }
    this.honoRating = numb;
    let slug: string = this._routeParams.snapshot.params['businessslug'];
    let stationId: string = this._routeParams.snapshot.params['section'];
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
      'Content-Type': 'application/json',
      Operation: 'UPDATE.HONO.RESPONSE',
      OperationMode: this.operationMode,
      PortalDS: 'DEVCITY',
    });
    let data = {
      items: [
        {
          HonoHandle: slug,
          HonoRating: numb,
          ResponseID: responseId ? responseId : null,
          StationID: stationId ? stationId : null,
          UserName: this.Form1.get('Name').value,
          UserMobile: this.Form1.get('Phone').value,
          Remarks: this.Form1.get('Comments').value,
          UserEmailID: this.Form1.get('Email').value,
        },
      ],
    };
    this._feedbackService.saveHonoEmoji(data, headers).subscribe((data) => {
      this.rating = numb;
      if (!responseId) {
        if (
          this.honoData?.PromptUserInfo === 'N' ||
          (this.honoData?.PromptUserInfo === 'E' && numb > 2)
        ) {
          this.onClick();
        } else {
          this.operationMode = 'E';
        }
      } else {
        this.submitted = true;
      }
      this.responseId = data['payload']['J'][0]['NewEntity'];
    });
  }
  // test

  getOtpMobile(isNew) {
    this.sendingOtp = true;
    this.errorMessage = '';
    if (this.loginData['SMSActivated'] === 'Y') {
      if (
        !this.MobileNumber ||
        this.MobileNumber.length != this.loginData['MobileNumberLength']
      )
        return (this.errorMessage = 'Enter a valid Phone number');
      let data = {
        items: [
          {
            CountryCode: this.loginData['CountryCode'],
            MobileNumber: this.MobileNumber,
            LanguageID: '100000',
            CountryID: JSON.stringify(this.loginData['CountryID']),
          },
        ],
      };
      const headers = new HttpHeaders({
        Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
        Operation: 'LOGIN.BY.MOBILE',
        'Content-Type': 'application/json',
        AuthChannel: 'M',
        SignUpSource: 'A',
        PortalContext: this.companyData['PortalDS'],
        Encryption: 'noitpyrcne',
        RecoverPassword: 'Y',
        Format: 'N',
      });
      this._feedbackService.loginViaMobile(data, headers).subscribe(
        (data) => {
          if (isNew) {
            // this.loginModalClose.nativeElement.click();
            this.otpModalButton.nativeElement.click();
          }
          this.loginResponse = data['payload'];
          this.startTimer();
        },
        (error) => {
          this.sendingOtp = false;
        }
      );
    } else if (this.loginData['SMSActivated'] === 'N') {
      if (!this.EmailID) return (this.errorMessage = 'Enter a valid Email id');
      let data = {
        items: [
          {
            EmailID: this.EmailID,
            LanguageID: '100000',
            CountryID: JSON.stringify(this.loginData['CountryID']),
          },
        ],
      };
      const headers = new HttpHeaders({
        Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
        Operation: 'LOGIN.BY.EMAIL',
        'Content-Type': 'application/json',
        AuthChannel: 'E',
        SignUpSource: 'A',
        PortalContext: this.companyData['PortalDS'],
        Encryption: 'noitpyrcne',
        RecoverPassword: 'Y',
        Format: 'N',
      });
      this._feedbackService.loginViaEmail(data, headers).subscribe(
        (data) => {
          if (isNew) {
            this.loginModalClose.nativeElement.click();
            this.otpModalButton.nativeElement.click();
          }
          this.loginResponse = data['payload'];
          this.startTimer();
        },
        (error) => {
          this.sendingOtp = false;
        }
      );
    }
  }

  reloadPageAfterNTime() {
    const timeOut = parseInt(this.honoData?.ScreeenTimeoutPeriod) * 1000;
    console.log(timeOut);

    setTimeout(() => {
      window.location.reload();
    }, timeOut);
  }

  startTimer() {
    this.sendingOtp = false;
    this.otpSent = true;
    this.secondsToDelay = parseInt(this.honoData?.ScreeenTimeoutPeriod);
    const interval = setInterval(() => {
      this.secondsToDelay--;
      if (this.secondsToDelay === 0) {
        this.otpSent = false;
        clearInterval(interval);
      }
    }, 1000);
  }

  verifyOtp() {
    this.errorMessage = '';
    if (!this.EnteredOTP) return (this.errorMessage = 'Fill OTP');
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
      Operation: 'VERIFY.OTP',
      OTPHandle: this.loginResponse['J'][0]['OTPHandle'],
      EnteredOTP: this.EnteredOTP,
      'Content-Type': 'application/json',
      PortalContext: this.companyData['PortalDS'],
      Encryption: 'noitpyrcne',
      Format: 'N',
    });
    this._feedbackService.verifyOtp(headers).subscribe(
      (data) => {
        this.otpVerifyResponse = data['payload'][1][0];
        this.getProfile(data['payload'][1][0].CitizenHandle);
        this.isLoggedInVar = true;
      },
      (error) => {
        this.errorMessage = 'Invalid OTP';
      }
    );
  }

  OnSaveName() {
    let data = {
      items: [
        {
          CitizenName: this.CitizenName,
          CitizenHandle: this.CitizenHandle,
        },
      ],
    };
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
      Operation: 'UPDATE.NAME',
      'Content-Type': 'application/json',
      PortalContext: this.companyData['PortalDS'],
      Encryption: 'noitpyrcne',
      Format: 'N',
    });
    try {
      this._feedbackService.isLoggedIn(data, headers).subscribe((data) => {
        // this.Citizen = data;
        this.nameModalClose.nativeElement.click();
        this.getProfile(this.CitizenHandle);
        if (this.honoData?.VerifyCitizenship === 'Y') {
          if (this.honoData?.PromptUserInfo !== 'N') {
            this.saveRatingAPI(this.rating, this.responseId);
          }
          this.reloadPageAfterNTime();
        }
        // this.companyData = data['ManikJSon'][0]['JSon0'][0];
        // console.log(this.Citizen);
      });
    } catch (e) {
      console.log(e);
    }
  }

  getProfile(CitizenHandle) {
    let obj = {
      items: [{ CitizenHandle: CitizenHandle }],
    };
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
      Operation: 'GET.PROFILE',
      'Content-Type': 'application/json',
      PortalContext: this.companyData['PortalDS'],
      Encryption: 'noitpyrcne',
      Format: 'N',
    });
    this._feedbackService.getProfile(obj, headers).subscribe((data) => {
      this.otpModalClose.nativeElement.click();
      this.CitizenHandle = data['payload']['J'][0].CitizenHandle;
      if (data['payload']['J1'][0]['Name'] === 'INCOMPLETE') {
        this.CitizenName = this.Form1.value['Name'];
        this.openloginname.nativeElement.click();
      } else {
        this.userData = data['payload']['J'][0];
        console.log('  this.userData', this.userData);
        if (this.honoData?.PromptUserInfo !== 'N') {
          this.saveRatingAPI(this.rating, this.responseId);
        } else {
          this.reloadPageAfterNTime();
        }

        this.Form1.setValue({
          Email: this.userData.EmailID,
          Name: this.userData.CitizenName,
          Phone: this.userData.MobileNumber,
          Comments: '',
        });
      }
    });
  }
}
